<template>
	<div v-if="isMobile" class="background-effect" data-number="3" data-colours="#D490FF,#E8BCCD,#FFF090">
		<svg width="460" height="407" viewBox="0 0 460 407"
			style="top: -17.5442%; left: 44.9886%; animation-duration: 74.0107s; transform-origin: -5.68896vw -10.4816vh; animation-direction: normal; animation-delay: -9.24452s;">
			<path
				d="M911.962 377l-200-346.41A60 60 0 00660 .59H260a60 60 0 00-51.962 30L8.038 377a60 60 0 000 60l200 346.41a60 60 0 0051.962 30h400a60 60 0 0051.962-30l200-346.41a60 60 0 000-60zm-121.243 30L625.36 693.41H294.641L129.282 407l165.36-286.411h330.717L790.719 407z"
				fill="#D490FF"></path>
		</svg>
		<svg width="460" height="407" viewBox="0 0 460 407"
			style="top: -44.3114%; left: 26.9682%; animation-duration: 83.926s; transform-origin: 9.40974vw 59.8291vh; animation-direction: normal; animation-delay: -8.90369s;">
			<path
				d="M911.962 377l-200-346.41A60 60 0 00660 .59H260a60 60 0 00-51.962 30L8.038 377a60 60 0 000 60l200 346.41a60 60 0 0051.962 30h400a60 60 0 0051.962-30l200-346.41a60 60 0 000-60zm-121.243 30L625.36 693.41H294.641L129.282 407l165.36-286.411h330.717L790.719 407z"
				fill="#E8BCCD"></path>
		</svg>
		<svg width="460" height="407" viewBox="0 0 460 407"
			style="top: -24.9759%; left: 19.4258%; animation-duration: 68.8948s; transform-origin: 47.8268vw 47.326vh; animation-direction: reverse; animation-delay: -2.91818s;">
			<path
				d="M911.962 377l-200-346.41A60 60 0 00660 .59H260a60 60 0 00-51.962 30L8.038 377a60 60 0 000 60l200 346.41a60 60 0 0051.962 30h400a60 60 0 0051.962-30l200-346.41a60 60 0 000-60zm-121.243 30L625.36 693.41H294.641L129.282 407l165.36-286.411h330.717L790.719 407z"
				fill="#FFF090"></path>
		</svg>
	</div>
	<div v-else class="background-effect" data-number="3" data-colours="#D490FF,#E8BCCD,#FFF090">
		<svg width="920" height="814" viewBox="0 0 920 814"
			style="top: -17.5442%; left: 44.9886%; animation-duration: 74.0107s; transform-origin: -5.68896vw -10.4816vh; animation-direction: normal; animation-delay: -9.24452s;">
			<path
				d="M911.962 377l-200-346.41A60 60 0 00660 .59H260a60 60 0 00-51.962 30L8.038 377a60 60 0 000 60l200 346.41a60 60 0 0051.962 30h400a60 60 0 0051.962-30l200-346.41a60 60 0 000-60zm-121.243 30L625.36 693.41H294.641L129.282 407l165.36-286.411h330.717L790.719 407z"
				fill="#D490FF"></path>
		</svg>
		<svg width="920" height="814" viewBox="0 0 920 814"
			style="top: -44.3114%; left: 26.9682%; animation-duration: 83.926s; transform-origin: 9.40974vw 59.8291vh; animation-direction: normal; animation-delay: -8.90369s;">
			<path
				d="M911.962 377l-200-346.41A60 60 0 00660 .59H260a60 60 0 00-51.962 30L8.038 377a60 60 0 000 60l200 346.41a60 60 0 0051.962 30h400a60 60 0 0051.962-30l200-346.41a60 60 0 000-60zm-121.243 30L625.36 693.41H294.641L129.282 407l165.36-286.411h330.717L790.719 407z"
				fill="#E8BCCD"></path>
		</svg>
		<svg width="920" height="814" viewBox="0 0 920 814"
			style="top: -24.9759%; left: 19.4258%; animation-duration: 68.8948s; transform-origin: 47.8268vw 47.326vh; animation-direction: reverse; animation-delay: -2.91818s;">
			<path
				d="M911.962 377l-200-346.41A60 60 0 00660 .59H260a60 60 0 00-51.962 30L8.038 377a60 60 0 000 60l200 346.41a60 60 0 0051.962 30h400a60 60 0 0051.962-30l200-346.41a60 60 0 000-60zm-121.243 30L625.36 693.41H294.641L129.282 407l165.36-286.411h330.717L790.719 407z"
				fill="#FFF090"></path>
		</svg>
	</div>
</template>


<script>
	export default {
		props: ['isMobile']
	}
</script>
